// A mock function to mimic making an async request for data
import api from '../../utils/api'

export function getInvoiceReport(payload: any) {
  return api('/api/admin/invoicing', 'GET', payload)
}